<img
  class="h-full w-full rounded-full"
  data-testid="client-image"
  [alt]="imagePath + ' client logo'"
  [src]="cdnClientBaseUrl + (imagePath || defaultClientImagePath)" />
